(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["what-renter-says"] && !Shopify.designMode) return;
  try {
    
jQuery('.what-renters-textBox  #rMore').click(function(){
    jQuery('.what-renters-textBox .renters-textBox-item').addClass('showAll-items');
});

  } catch(e) { console.error(e); }
})();
})();
